/* stylelint-disable property-no-unknown */
:export {
  sm: 766px;
  md: 1148px;
}

/* stylelint-disable property-no-unknown */
/* Function mapping */
:export {
  WHITE: #fff;
  OFF_WHITE: #f6f6f8;
  VERY_LIGHT_GREY: #e9e9e9;
  VERY_LIGHT_GRAY: #e9e9e9;
  LIGHT_GREY: rgba(204, 204, 204, 0.8);
  LIGHT_GRAY: rgba(204, 204, 204, 0.8);
  GREY: #848484;
  GRAY: #848484;
  CHARCOAL: #353a40;
  DARK_GREY: #252525;
  DARK_GRAY: #252525;
  BLACK: #000;
  GREEN: #0db14b;
  INDICATOR_BLUE: #1f69ff;
  BLUE: #0089cf;
  PURPLE: #645faa;
  BOLD_PURPLE: #6138f5;
  RED: #f00;
  YELLOW: #fdb913;
  ORANGE: #f37021;
  ROSE: #b42846;
  BODY_TEXT: #353a40;
  INDICATOR: #1f69ff;
}

.dashboard-container {
  min-height: 374px;
  margin: 40px 0;
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 30px;
}
@media screen and (min-width: 766px) and (max-width: 1148px) {
  .dashboard-container {
    grid-template-columns: 1fr;
  }
}
@media screen and (width <= 765px) {
  .dashboard-container {
    grid-template-columns: 1fr;
  }
}
.dashboard-container .user-info {
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 445px;
}
@media screen and (width <= 765px) {
  .dashboard-container .user-info {
    min-width: initial;
  }
}
@media screen and (min-width: 766px) and (max-width: 1148px) {
  .dashboard-container .user-info {
    flex-direction: row;
  }
  .dashboard-container .user-info > * {
    flex: 1;
  }
}
.dashboard-container .articles-content {
  max-height: 374px;
  overflow: auto;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.dashboard-container .articles-content .title {
  font-weight: bold;
  font-size: 18px;
  line-height: 28px;
}
.dashboard-container .no-articles {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5em;
}
.dashboard-container .no-articles h5 {
  font-weight: bold;
}
.dashboard-container .no-articles svg {
  color: #6138f5;
  height: 45px;
  width: 45px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */